export const copyWarning =
  'Are you sure you would like to copy this submission into a new draft report?';
